module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1276-retro.f92bca06.jpg";